import { MARQUEE_ITEMS } from "@/data";

function Track({ hidden }) {
    return (
        <div className="marquee-group" aria-hidden={hidden || undefined}>
            {MARQUEE_ITEMS.map((item, i) => (
                <span className="marquee-item" key={`${item}-${i}`}>
                    {item}
                    <span className="marquee-sep">◆</span>
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <div className="marquee" data-testid="editorial-marquee">
            <div className="marquee-track">
                <Track />
                <Track hidden />
            </div>
        </div>
    );
}
